import type { MemberProductMapProduct } from '~~/shared/globalTypes/product';

export const isUpcsAvaiable = (p: MemberProductMapProduct | null | undefined) => {
  if (!p) {
    return false;
  }
  const hasUpcs = p.relationships?.upcs && Object.keys(p.relationships.upcs).length > 0;
  return !!hasUpcs;
};

export default isUpcsAvaiable;
